import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const DrmVideoPlayer = ({ videoId }) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Load Shaka Player scripts and styles
    const loadShakaPlayer = () => {
      return new Promise((resolve, reject) => {
        // Check if already loaded
        if (window.shaka) {
          resolve();
          return;
        }

        // Load CSS
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/shaka-player/3.1.0/controls.min.css';
        link.integrity = 'sha512-lci2V6vCEYjVdTlsGTN+xcN5DglyDLKSO/x41R1a/LSjJ7o4NOrxv9/eZGkuV6ppA9miB90cO2IIrfJ7tMzsqg==';
        link.crossOrigin = 'anonymous';
        link.referrerPolicy = 'no-referrer';
        document.head.appendChild(link);

        // Load JS
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/shaka-player/3.1.0/shaka-player.ui.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Shaka Player'));
        document.head.appendChild(script);
      });
    };

    const initPlayer = async () => {
      if (!videoId) {
        setError('No video ID provided');
        setLoading(false);
        return;
      }

      try {
        // Load Shaka Player
        await loadShakaPlayer();

        // Fetch video details from VideoCrypt API
        const formData = new FormData();
        formData.append('flag', '1');
        formData.append('name', videoId);

        const response = await axios.post(
          'https://api.videocrypt.com/getVideoDetailsDrm',
          formData,
          {
            headers: {
              accessKey: 'NUIzQVhZRDFGUkhFOU44UTcwTDI=',
              secretKey: 'NS80OFJ5RUl0dz1CbE5VNmczYVRvTVN4dnVLY1haWW43MkhiVnJlVw==',
              'user-id': 'TESTing_10000903_97',
              'device-type': '1',
              'device-id': '71d3548555586126ed7071102e663619',
              version: '2',
              'device-name': 'ChromeCDM',
              'account-id': '10000903',
            },
          }
        );

        const result = response.data;
        const timestamp = new Date().getTime();
        const videoUrlWithCacheBust = result.data.link.file_url;
        const manifestUri = `${videoUrlWithCacheBust}?t=${timestamp}`;
        const token = result.data.link.token;
        const licenseServer = 'https://license.videocrypt.com/validateLicense';

        // Destroy existing player if it exists
        if (playerRef.current) {
          await playerRef.current.destroy();
          playerRef.current = null;
        }

        // Initialize Shaka Player
        const player = new window.shaka.Player(videoRef.current);
        playerRef.current = player;

        // Configure DRM
        player.configure({
          drm: {
            servers: {
              'com.widevine.alpha':
                licenseServer + '?pallycon-customdata-v2=' + token,
            },
          },
        });

        // Setup UI
        const ui = new window.shaka.ui.Overlay(
          player,
          containerRef.current,
          videoRef.current
        );
        const config = {};
        ui.configure(config);
        ui.getControls();

        // Load video
        await player.load(manifestUri);
        console.log('Video loaded successfully');
        setLoading(false);
      } catch (err) {
        console.error('Error loading video:', err);
        setError(err.message || 'Failed to load video');
        setLoading(false);
      }
    };

    initPlayer();

    // Cleanup
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy().catch(console.error);
        playerRef.current = null;
      }
    };
  }, [videoId]);

  if (error) {
    return (
      <div
        style={{
          padding: '20px',
          background: '#f8d7da',
          color: '#721c24',
          borderRadius: '4px',
          textAlign: 'center',
        }}
      >
        <p>Error loading video: {error}</p>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 10,
          }}
        >
          <p>Loading video...</p>
        </div>
      )}
      <div
        ref={containerRef}
        id="videoContainer"
        style={{
          position: 'relative',
          paddingBottom: '56.25%',
          height: 0,
          overflow: 'hidden',
          maxWidth: '100%',
          background: '#000',
        }}
      >
        <video
          ref={videoRef}
          id="videoComponent"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />
      </div>
    </div>
  );
};

export default DrmVideoPlayer;
